'use client'

import useHotelDetailStore from '@/core/stores/hotelDetail';
import Image from 'next/image';
const regex = /[.](?=[A-Z ])/;
export default function Policies() {
    const { policies } = useHotelDetailStore()
    return (
        policies ? <div id="policies" className="pb-6 border-b border-neutral-200">

            <div className=''>
                <h2 className="flex flex-row gap-2">
                    <span className="text-sm font-semibold text-gray-800">
                        Things to keep in mind
                    </span>
                </h2>
                <ul className="flex list-disc flex-col gap-2 pl-4 pt-2 text-sm font-normal text-gray-700">
                    {policies
                        .replace('Rate Notes:\n\nHotel Tariff Notes:\n', '').replaceAll('&quot;', '')}
                </ul>
            </div>

        </div > :
            <div className='flex w-full items-center flex-col'>
                <div className='flex items-center justify-center mt-4'>
                    <Image className='w-full max-w-[170px]' alt="Planingo" width={500} height={500} src={'https://planingo.ai/wp-content/uploads/2024/08/empty_state.png'} />
                </div>
            </div>
    );
}